import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "ro",
  setLang: () => {},
  t: translations.ro,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("ro");

  const setLang = useCallback((next) => {
    if (next === "ro" || next === "en") setLangState(next);
  }, []);

  const value = {
    lang,
    setLang,
    t: translations[lang],
  };

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
